import * as yup from 'yup';

export const initialValuesStepTwo = {};

export const schemaStepTwo = yup.object().shape({});

export const titleStepTwo = 'Método de pago';
